// API success can mean the profile was saved while activation is still pending.
export function onboardingNotice(response) {
  const payload = response?.data;
  const pending = response?.status === 202;
  const message =
    typeof payload?.message === "string"
      ? payload.message
      : "Account saved. Check its activation status before asking the user to sign in.";
  return { message, variant: pending ? "warning" : "success" };
}

export function onboardingErrorMessage(error) {
  const payload = error?.response?.data;
  if (typeof payload?.message === "string") return payload.message;
  if (typeof payload === "string") return payload;
  return "The request could not be completed. Retry the same details or contact an administrator.";
}
